<script>
import ApiService from '../../service/ApiService'
import { store } from '../../base/Store'

export default {
  name: 'search',

  data: () => ({
    sharedState: store.state
  }),

  render () {
    return this.$scopedSlots.default({
      search_form: this.sharedState.searchQuery,
      searchId: this.searchId,
      onInput: this.onInput
    })
  },

  methods: {
    async searchId () {
      try {
        const response = await ApiService.searchById(this.sharedState.searchQuery)
        if (!response) {
          let obj = {
            title: 'Oops!',
            message: 'We couldn’t find what you are looking for.',
            type: 'error'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        } else {
          if (response.type !== 'tx' &&
              response.type !== 'block' &&
              response.type !== 'address') {
            let obj = {
              title: 'Oops!',
              message: 'Internal error. Please let us know.',
              type: 'error'
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          }
          this.$router.push({
            path: `/${response.type}/${this.sharedState.searchQuery}`
          })
          store.clearMessageAction()
        }
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
        throw error
      }
    },

    onInput (event) {
      store.setMessageAction(event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/Search.vue